import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {RouteService} from '../../../../core/services/route.service';
import {CartStore} from '../../../../core/stores/cart.store';
import {PaymentStore} from '../../../../core/stores/payment.store';

@Component({
  selector: 'app-tab-modal',
  templateUrl: './tab-modal.component.html',
  styleUrls: ['./tab-modal.component.scss']
})
export class TabModalComponent implements OnInit {
  @Input() isGroup: boolean;
  @Output() close = new EventEmitter<boolean>();

  public get tabIsClosed(): boolean {
    if (this.cartStore.tab) {
      return this.cartStore.tab.is_closed;
    } else {
      return this.cartStore.groupTab.is_closed;
    }
  }

  public get tab(): any {
    return this.cartStore.tab || this.cartStore.groupTab;
  }

  constructor(private router: Router,
              private routeService: RouteService,
              public cartStore: CartStore,
              public paymentStore: PaymentStore) { }

  ngOnInit() {
  }

  closeTabPageLink() {
    const url = this.isGroup ? this.routeService.getGroupUrl() : this.routeService.getLocationUrl();
    this.router.navigate([url, 'close-tab'])
        .catch(error => console.error(error));
      this.closeModal();
    }

  closeModal() {
    if (this.cartStore.tab && this.cartStore.tab.is_closed) {
      this.cartStore.tab = null;
    } else if (this.cartStore.groupTab && this.cartStore.groupTab.is_closed) {
      this.cartStore.groupTab = null;
    }
    this.cartStore.tabClosedSuccessful = false;
    this.close.emit();
  }
}
